
const equipoRutes = [
  {
    path: '/ds/equipo/:usernameTeam',
    component: () => import('../views/team/IndexTeamPage.vue'),
    meta: {requiresAuth: true},
    children: [
      {
        path: '',
        name: 'team-page',
        component: () => import('../views/team/TeamPage.vue'),
        children: [
          {
            path: 'torneos',
            name: 'team-torneos',
            component: () => import('../views/team/TeamTorneosPage.vue'),
          },
          {
            path: 'plantel/:idTorneo/jugadores',
            name: 'team-torneo-plantel',
            component: () => import('../views/team/TeamPlantelPage.vue'),
          },
          {
            path: 'partidos',
            name: 'team-partidos',
            component: () => import('../views/team/TeamPartidosPage.vue'),
          },
          {
            path: 'noticias',
            name: 'team-news',
            component: () => import('../views/team/TeamNewsPage.vue'),
          },
          {
            path: 'reportes',
            name: 'team-reportes',
            component: () => import('../views/team/TeamReportesPage.vue'),
          },
        ]
      },
    ]
  },
]

export default equipoRutes
